import { RootState } from "app/store";

export const selectDriverMileageLoading = (state: RootState) =>
  state.rootReducer.driverMileageReducer?.loading ?? false;

export const selectDriverMileageList = (state: RootState) =>
  state.rootReducer.driverMileageReducer?.driverMileageList ?? [];

export const selectDriverMileageTotalRecords = (state: RootState) =>
  state.rootReducer.driverMileageReducer?.totalRecords ?? 0;

export const selectDriverMileageState = (state: RootState) => ({
  loading: selectDriverMileageLoading(state),
  driverMileageList: selectDriverMileageList(state),
  totalRecords: selectDriverMileageTotalRecords(state)
});
